import { createSlice } from "@reduxjs/toolkit";
import { sendEmailMessage } from "../thunks/emailThunks";

interface EmailState {
  loading: boolean;
  error: string | null;
  success: boolean;
  message: string | null;
}

const initialState: EmailState = {
  loading: false,
  error: null,
  success: false,
  message: null,
};

const emailSlice = createSlice({
  name: "email",
  initialState,
  reducers: {
    resetEmailState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendEmailMessage.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
        state.message = null;
      })
      .addCase(sendEmailMessage.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.message = action.payload.message;
      })
      .addCase(sendEmailMessage.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "שגיאה בשליחת אימייל";
      });
  },
});

export const { resetEmailState } = emailSlice.actions;
export default emailSlice.reducer;
